export { wrapRootElement } from './src/apollo/wrap-root-element'
